
export type UserRole = 'member' | 'admin' | 'cfi' | 'student' | 'dispatch' | 'maintenance';

// Helper function to get role display name (short form for UI)
export function getRoleDisplayName(role: UserRole): string {
  const roleNames: Record<UserRole, string> = {
    admin: 'Admin',
    member: 'Member',
    cfi: 'CFI',
    student: 'Student',
    dispatch: 'Dispatch',
    maintenance: 'Maintenance'
  };
  return roleNames[role] || role;
}

// Helper function to get full role display name
export function getRoleDisplayNameFull(role: UserRole): string {
  const roleNames: Record<UserRole, string> = {
    admin: 'Administrator',
    member: 'Member',
    cfi: 'Certified Flight Instructor',
    student: 'Student Pilot',
    dispatch: 'Flight Dispatcher',
    maintenance: 'Maintenance Personnel'
  };
  return roleNames[role] || role;
}

// Helper function to get role description
export function getRoleDescription(role: UserRole): string {
  const descriptions: Record<UserRole, string> = {
    admin: 'Full administrative access to organization and all features',
    member: 'Standard pilot access for booking flights and managing profile',
    cfi: 'Can instruct students, approve flight plans, and manage training progress',
    student: 'Limited access for training flights and progress tracking',
    dispatch: 'Can coordinate flights, override conflicts, and manage scheduling',
    maintenance: 'Can manage aircraft maintenance, squawks, and work orders'
  };
  return descriptions[role] || 'Unknown role';
}

export interface UserProfile {
  id: string;
  email: string;
  name: string;
  lastName: string;
  orgId?: string;
  role: UserRole;
  createdAt: Date;
  updatedAt: Date;
}

export interface UserInput {
  email: string;
  name: string;
  lastName: string;
  orgId?: string;
  role: UserRole;
}

// Extend Firebase User with our custom fields
export interface User {
  uid: string;
  email: string | null;
  displayName: string | null;
  firstName?: string;
  lastName?: string;
  role: 'admin' | 'member' | 'cfi' | 'student' | 'dispatch' | 'maintenance';
  orgId?: string;
  createdAt: Date;
  updatedAt: Date;
} 